module.exports = __webpack_public_path__ + "static/media/Mongo.32f4126c.jpg";